import { axiosApi } from "../../../../../api/dbAxios";

export const fetchTeamData = async (id: number) => {
  try {
    const response = await axiosApi.get(`/teams/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching team data:", error);
    return [];
  }
};
